//export const API_BASE_URL = 'http://localhost:5000';

export const API_BASE_URL = "https://reagent-management.onrender.com";
